<template>
    <div class="about">
        <h2>About</h2>
        <inner-page-banner-component></inner-page-banner-component>
    </div>
</template>

<script>
    import InnerPageBannerComponent from "../views/partials/InnerPageBannerComponent";

    export default {
        name: "AboutComponent",
        components: {InnerPageBannerComponent}
    }
</script>

<style scoped>

</style>